module.exports = __webpack_public_path__ + "img/elementary-school-course-description-1.0ab293b1.svg";